"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var getSelector_1 = require("./getSelector");
function getConfig(_a, inputConfig) {
    var $ = _a.$, el = _a.el;
    if (!inputConfig)
        return null;
    if (typeof inputConfig === 'function') {
        inputConfig = inputConfig($ && el ? $(el) : null);
    }
    if (typeof inputConfig === 'string' || Array.isArray(inputConfig)) {
        inputConfig = getSelector_1["default"](inputConfig);
    }
    else if (inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.selector) {
        var config_1 = inputConfig;
        inputConfig = __assign(__assign({}, config_1), getSelector_1["default"](config_1.selector));
    }
    var methods = inputConfig.methods;
    var type = (methods === null || methods === void 0 ? void 0 : methods.includes('array')) ? 'array' : inputConfig.type;
    var html = (methods === null || methods === void 0 ? void 0 : methods.includes('html')) ? true : inputConfig.html;
    var exist = (methods === null || methods === void 0 ? void 0 : methods.includes('exist')) ? true : inputConfig.exist;
    var trim = (methods === null || methods === void 0 ? void 0 : methods.includes('trim')) ? true : inputConfig.trim;
    trim = (methods === null || methods === void 0 ? void 0 : methods.includes('non-trim')) ? false : inputConfig.trim;
    if (type)
        inputConfig.type = type;
    if (html)
        inputConfig.html = html;
    if (exist)
        inputConfig.exist = exist;
    if (typeof trim === 'boolean')
        inputConfig.trim = trim;
    var config = inputConfig;
    return config;
}
exports["default"] = getConfig;
